'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTextField = require('../cwtextfield/CwTextField');

var _CwTextField2 = _interopRequireDefault(_CwTextField);

var _CwLabel = require('../cwlabel/CwLabel');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

var _CwCurrencyField = require('./CwCurrencyField.scss');

var _CwCurrencyField2 = _interopRequireDefault(_CwCurrencyField);

var _NumberUtils = require('../../utils/NumberUtils');

var _Enums = require('../../utils/Enums');

var _PolyFillFunctions = require('../..//utils/PolyFillFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwCurrencyField = function (_React$Component) {
  (0, _inherits3.default)(CwCurrencyField, _React$Component);

  function CwCurrencyField(props) {
    (0, _classCallCheck3.default)(this, CwCurrencyField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwCurrencyField.__proto__ || (0, _getPrototypeOf2.default)(CwCurrencyField)).call(this, props));

    _this.handleChange = function (value) {
      //Keep acceptable states and bypass all other checks
      if ((0, _NumberUtils.checkAcceptableChangeState)(value, _this.props.negative, _this.props.decimal)) {
        _this.setState({
          value: value
        });
        _this.props.onChange(null);
        return;
      } else if ((0, _NumberUtils.undesirableCurrencyFieldStates)(value, _this.props.negative, _this.props.decimal)) {
        //Handle undesired states and restrict them on key entry
        _this.props.onChange(null);
        return;
      }

      //Do not allow more units after decimal than maxDecimalUnits plus period and only allow one decimal
      if ((0, _NumberUtils.checkforOneDecimalAndMaxDecimalUnits)(value, _this.props.decimal, _this.props.maxDecimalUnits)) {
        _this.restrictLastDigit(value);
        return;
      }

      //Restrict left field by max length prop unless the last digit is a decimal, then allow extra char. 
      if (!(0, _NumberUtils.checkDecimalAgainstMaxLength)(value, _this.props.decimal, (0, _NumberUtils.generateMaxLength)(_this.state.value, _this.props.maxLength, _this.props.decimal, _this.props.maxDecimalUnits))) {
        _this.restrictLastDigit(value);
        return;
      }

      //Allow no more than 1 negative symbol
      if ((0, _PolyFillFunctions.Includes)(value, "-") || (0, _PolyFillFunctions.Includes)(value, _this.props.negative)) {
        if (value.match(new RegExp("[-" + _this.props.negative + "]", "g")).length !== 1) {
          _this.restrictLastDigit(value);
          return;
        }
      }
      _this.setState({
        value: value
      });
      var newVal = _this.formatToFloat(value);
      if (isNaN(newVal) || typeof newVal === 'undefined') {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(newVal);
      }
    };

    _this.restrictLastDigit = function (value) {
      var newVal = value.substring(0, value.length - 1);
      _this.setState({
        value: newVal
      });
      if (isNaN(_this.formatToFloat(newVal))) {
        _this.props.onChange(null);
        return;
      }
      _this.props.onChange(_this.formatToFloat(newVal));
    };

    _this.handleBlur = function () {
      _this._focused = false;

      if (_this.state.value || _this.state.value === 0) {
        _this.formatDisplayValue(_this.state.value);
      }

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };

    _this.handleFocus = function () {
      _this._focused = true;
      _this._typing = false;

      if (_this.state.value) {

        //First let's get a float to work with, stripping away all special characters
        var newVal = _this.formatToFloat(_this.state.value);

        if (isNaN(newVal)) {
          _this.setState({
            value: ''
          });
          return;
        }
        // Now lets convert that float back to a string and add in the correct decimal, but only if it's not "."
        if (_this.props.decimal !== ".") {
          newVal = newVal.toString().replace('.', _this.props.decimal);
        }

        //Finally set the state
        _this.setState({
          value: newVal.toString()
        });
      }
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    };

    _this.handleKeyDown = function () {
      _this._typing = true;
    };

    _this.formatDisplayValue = function (value) {

      var newVal = _this.formatDisplayValueWithoutStateChange(value);

      var floatNewVal = _this.formatToFloat(newVal);

      if (isNaN(floatNewVal)) {
        _this.props.onChange(null);
      } else {
        _this.props.onChange(floatNewVal);
      }

      _this.setState({
        value: newVal
      });

      return newVal;
    };

    _this.formatDisplayValueWithoutStateChange = function (value) {

      var newVal = void 0;
      if ((0, _NumberUtils.typeOf)(value) === 'String') {
        var temp = value.split(_this.props.thousands).join('');
        temp = temp.replace(_this.props.symbol, '');
        temp = temp.replace(_this.props.decimal, '.');
        temp = parseFloat(temp);
        newVal = _this.props.formatToCurrency(temp);
      } else if (isNaN(value) || value === undefined) {
        newVal = '';
      } else if ((0, _NumberUtils.typeOf)(value) === 'Number') {
        newVal = _this.props.formatToCurrency(value);
      }

      //Check for NaN
      if (isNaN(_this.formatToFloat(newVal))) {
        return '';
      }
      return newVal;
    };

    _this.formatToFloat = function (value) {
      if (!value || typeof value !== "string") {
        return;
      }
      var temp = value.replace(_this.props.symbol, '');
      return (0, _NumberUtils.formatToAFloat)(temp, _this.props.thousands, _this.props.decimal, _this.props.negative);
    };

    _this.state = {
      value: _this.formatDisplayValueWithoutStateChange(_this.props.value),
      regex: (0, _NumberUtils.generateCurrencyRegex)(_this.props.negative, _this.props.decimal)
    };
    _this._typing = false;
    _this._focused = false;
    return _this;
  }

  /**
   * Handle getting an empty string as props
   */


  (0, _createClass3.default)(CwCurrencyField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _NumberUtils.checkNextPropsWhileNotTyping)(nextProps.value, this._focused)) {
        this.setState({
          value: this.formatDisplayValueWithoutStateChange(nextProps.value)
        });
      } else if ((nextProps.value || nextProps.value === '' || nextProps.value === 0) && (!this.state.value || this.state.value === '')) {
        this.setState({
          value: nextProps.value.toString()
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.selectAllOnFocus && this._focused && !this._typing) {
        this.textField.inputField.select();
      }
    }

    /**
     * Handle exceptions before passing the change value up the chain
     */


    //This method gets called when more then one negative or decimal are used


    /**
     * onBlur, convert float or int to a currency string.
     */


    /**
     * On focus, convert string to a float.
     */


    /**
     * After converting a number from a string, we need to update the state and call onChange
     *
     */


    /**
     * Converts a number or a string to to be displayed via the localized
     * formatNumber method provided by ReactIntl.
     */


    /**
     * Format's a string to a float with special handling for currency characters
     * such as $ and , within the string. These characters should be provided to the method
     * so that it knows what to strip out. It also replaces the local decimal separator
     * with a . for the sake of parseFloat
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId, className: _CwCurrencyField2.default.currencyRoot },
        _react2.default.createElement(_CwTextField2.default, {
          ref: function ref(item) {
            return _this2.textField = item;
          },
          className: _CwCurrencyField2.default.currencyText,
          value: this.state.value,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onChange: this.handleChange,
          regex: this.state.regex,
          maxLength: (0, _NumberUtils.generateMaxLength)(this.state.value, this.props.maxLength, this.props.decimal, this.props.maxDecimalUnits),
          placeholder: this.props.placeholder,
          readOnly: this.props.readOnly,
          tabIndex: this.props.tabIndex,
          invalid: this.props.invalid,
          disabled: this.props.disabled,
          id: this.props.id,
          onKeyPress: this.props.onKeyPress,
          onKeyDown: this.handleKeyDown,
          textAlignment: this.props.textAlignment ? this.props.textAlignment : this.props.inAGrid ? _Enums.AlignmentEnum.RIGHT : undefined
        }),
        _react2.default.createElement(
          _CwLabel2.default,
          { className: _CwCurrencyField2.default.currencyCode },
          this.props.currency
        )
      );
    }
  }]);
  return CwCurrencyField;
}(_react2.default.Component);

CwCurrencyField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Text in textfield, should always come in as a number, we will handle formatting display.
   */
  value: _propTypes2.default.number,
  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes2.default.string,
  /**
   * Used to set textfield to a read only mode
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Callback function that is fired when textfield's text changes
   */
  onChange: _propTypes2.default.func,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes2.default.number,
  /**
   * Used to control if text is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable textfield
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used as an identifier for the component
   */
  id: _propTypes2.default.string,
  /**
   * Used to limit the inputs of the field by matching against provided string.
   */
  regex: _propTypes2.default.string,
  /**
   * Callback function that is fired when textfield is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when textfield is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function that is fired on key press
   */
  onKeyPress: _propTypes2.default.func,
  /**
   * The currency symbol of the current locale.
   * Recommend that this is acquired from React-Intl.
   */
  symbol: _propTypes2.default.string.isRequired,
  /**
   * The decimal separator for the current locale.
   * This can be provided from React or Java Intl.
   */
  decimal: _propTypes2.default.string.isRequired,
  /**
   * The thousands separator of the current locale
   * and is usually " ", ",", "." We recommend acquiring
   * this from React-Intl
   */
  thousands: _propTypes2.default.string.isRequired,

  /**
   * The negative symbol used by the current locale. Should
   * typically be a minus sign but unicode can vary
   */
  negative: _propTypes2.default.string.isRequired,
  /**
   * The maximum number of places after the decimal
   * which the currency accepts. This will usually be 2 or 3
   */
  maxDecimalUnits: _propTypes2.default.number.isRequired,
  /**
   * This function should format your float to a currency string value
   * We strongly suggest using React-Intl
   */
  formatToCurrency: _propTypes2.default.func.isRequired,
  /**
   * The max number of characters allowed in the field.
   * Should not exceed 13 excluding decimals and fractions
   */
  maxLength: _propTypes2.default.number,
  /**
   * The currency for the label.
   */
  currency: _propTypes2.default.string,
  /**
   * Used to control if all text is highlighted on focus
   */
  selectAllOnFocus: _propTypes2.default.bool
};

CwCurrencyField.defaultProps = {};

exports.default = CwCurrencyField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwcurrencyfield/CwCurrencyField.js
// module id = 824
// module chunks = 10